import { Autocomplete as MuiAutocomplete, Chip, TextField } from '@mui/material';
import styled from '@emotion/styled';
import { spacing } from '@mui/system';
import { grey } from '@mui/material/colors';

interface FilterOption {
  label: string;
  background?: string;
  lightText?: boolean;
}

export interface TableFilterProps {
  label?: string;
  options: FilterOption[];
  onFilterChange: (filter: string[]) => void;
}

const Autocomplete = styled(MuiAutocomplete)(spacing);

const TableFilterToolbar = ({ options, onFilterChange, label = 'Select filter' }: TableFilterProps) => {
  return (
    <Autocomplete
      mt={6}
      mb={4}
      ml={1}
      fullWidth
      multiple
      id="status-filter"
      options={options}
      defaultValue={[]}
      filterSelectedOptions
      isOptionEqualToValue={(option, value) => (option as FilterOption).label === (value as FilterOption).label}
      onChange={(_event, values) => onFilterChange((values as FilterOption[]).map((x) => x.label) as string[])}
      renderInput={(params) => <TextField {...params} label={label} />}
      renderTags={(value: any, getTagProps) =>
        value.map((option: FilterOption, index: number) => (
          <Chip
            {...getTagProps({ index })}
            size="small"
            label={option.label}
            sx={{
              ...(option.background && { background: option.background }),
              ...(option.lightText && {
                color: (theme) => theme.palette.common.white,
                '& .MuiChip-deleteIcon': {
                  color: grey[100],
                },
                '& .MuiChip-deleteIcon:hover': {
                  color: grey[300],
                },
              }),
            }}
          />
        ))
      }
    />
  );
};

export default TableFilterToolbar;
